var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('div',{style:({
    width: _vm.widthShow,
    height: _vm.heightShow,
    'background-size': '100% 100%',
    'background-repeat': 'no-repeat',
    'background-image': 'url(' + _vm.src + ')',
    'z-index': _vm.zIndex,
    position: 'relative',
    transform: _vm.transform,
    left: _vm.aligncenter ? '50%' : 'unset',
    top: _vm.justifycenter ? '50%' : 'unset',
  }),on:{"click":function($event){return _vm.$emit('click')},"touchstart":function (e) {
      _vm.$emit('touchstart', e);
    },"mousedown":function (e) {
      _vm.$emit('touchstart', e);
    },"mousemove":function (e) {
      _vm.$emit('touchmove', e);
    },"touchmove":function (e) {
      _vm.$emit('touchmove', e);
    },"touchend":function (e) {
      _vm.$emit('touchend', e);
    },"mouseup":function (e) {
      _vm.$emit('touchend', e);
    }}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fa74a64","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DlImage.vue
// module id = null
// module chunks = 